var React = require('react');

function IconPhone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 4.213C0 1.881 1.888 0 4.232 0h10.536C17.103 0 19 1.888 19 4.213v20.075c0 2.331-1.888 4.213-4.232 4.213H4.232C1.897 28.501 0 26.613 0 24.288V4.213zm2.111 0v20.075c0 1.156.951 2.102 2.121 2.102h10.536c1.179 0 2.121-.939 2.121-2.102V4.213c0-1.156-.951-2.102-2.121-2.102H4.232c-1.179 0-2.121.939-2.121 2.102zM9.5 23.75c-.874 0-1.583-.708-1.583-1.583s.709-1.583 1.583-1.583 1.583.709 1.583 1.583-.709 1.583-1.583 1.583z"}));
}

IconPhone.defaultProps = {"width":"19","height":"29"};

module.exports = IconPhone;

IconPhone.default = IconPhone;
